import Head from 'next/head';
import React from 'react';

const CLOUD_FRONT_URL = 'https://dffoxz5he03rp.cloudfront.net';
export const DEFAULT_KEYWORDS =
  '현지 투어, 여행 가이드, 투어 가이드, 현지 가이드, 가이드 투어, 마이리얼트립, 현지정보, 여행정보, 입장권, 교통패스, 액티비티, 여행사, 호텔예약, 해외호텔, 호텔할인, 즉시확정, 한인민박, 민박, 와이파이, 유심, 여행자보험, 항공권, 항공권 검색, 최저가 항공권';
const DEFAULT_IMAGE = {
  FAVICON: `${CLOUD_FRONT_URL}/logos/favicon.ico`,
  LOGO_SMALL: `${CLOUD_FRONT_URL}/logos/logo_mrt_v2_web_72x72.png`,
  LOGO_MEDIUM: `${CLOUD_FRONT_URL}/logos/logo_mrt_v2_web_120x120.png`,
  LOGO_LARGE: `${CLOUD_FRONT_URL}/logos/logo_mrt_v2_web_152x152.png`,
} as const;

const AppMeta = () => {
  return (
    <Head>
      <meta name="google-site-verification" content="SyCtjRv6wVxDU6a7dWgpsvQNMP38wW6OpOyMFBUkhQ8" />
      <meta name="robots" content="all, index, follow" />
      <meta name="locale" content="ko" />
      <meta name="currency" content="KRW" />
      <meta name="keywords" content={DEFAULT_KEYWORDS} />
      <meta name="facebook-domain-verification" content="cqj8gpiw2dzrca7olmmwdrwwc27zmh" />
      <meta property="al:ios:url" content="mrt://main" />
      <meta property="al:ios:app_store_id" content="1141745032" />
      <meta property="al:ios:app_name" content="마이리얼트립" />
      <meta property="al:android:url" content="mrt://main" />
      <meta property="al:android:package" content="com.mrt.ducati" />
      <meta property="al:android:app_name" content="마이리얼트립" />
      <meta property="fb:app_id" content="113823448739791" />
      <meta property="fb:admins" content="122600525" />
      <meta property="og:sv" content="마이리얼트립" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="MyRealtrip" />
      <meta property="article:publisher" content="https://www.facebook.com/myRealTrip" />
      <meta property="twitter:card" content="summary_large_image" />
      <link
        href="https://www.myrealtrip.com/opensearch.xml"
        rel="search"
        title="마이리얼트립 검색"
        type="application/opensearchdescription+xml"
      />
      <link href={DEFAULT_IMAGE.LOGO_SMALL} rel="apple-touch-icon-precomposed" />
      <link href={DEFAULT_IMAGE.LOGO_SMALL} rel="apple-touch-icon" />
      <link href={DEFAULT_IMAGE.LOGO_SMALL} rel="apple-touch-icon" sizes="76x76" />
      <link href={DEFAULT_IMAGE.LOGO_MEDIUM} rel="apple-touch-icon" sizes="120x120" />
      <link href={DEFAULT_IMAGE.LOGO_LARGE} rel="apple-touch-icon" sizes="152x152" />
      <link href={DEFAULT_IMAGE.FAVICON} rel="shortcut icon" type="image/x-icon" />
    </Head>
  );
};

export default AppMeta;
